import IconQilu from '@/images/h5-common/logo_qilu.webp';
import IconHuiya from '@/images/h5-common/logo_huiya.webp';
import React from 'react';
import { getSiteName, IS_HUIYA } from '../../config/domain';

// 定义Props接口
interface DownloadAppBannerProps {
  alignBottom?: boolean;
}

const DowloadAppBanner: React.FC<DownloadAppBannerProps> = ({ alignBottom = false }) => {
  const siteName = getSiteName();
  
  // 根据品牌获取不同的下载链接
  const downloadUrl = IS_HUIYA ? 'https://huiyabook.cn' : 'https://deerbook.cn';
  
  return (
    <div
      className={`fixed ${alignBottom ? 'bottom-0' : 'top-0'} left-0 right-0 bg-[#FFFFFF] flex items-center justify-between px-[16px] py-[8px]`}
    >
      {!IS_HUIYA ? (
        <div className='flex items-center'>
          <img src={IconQilu} alt='' className='w-[36px] h-[36px]' />
          <div className='ml-[8px]'>
            <div className='text-[16px] font-medium'>{siteName}</div>
            <div className='text-[12px] text-[#999999]'>英语学习平台</div>
          </div>
        </div>
      ) : (
        <div className='flex items-center'>
          <img src={IconHuiya} alt='' className='w-[36px] h-[36px]' />
          <div className='ml-[8px]'>
            <div className='text-[16px] font-medium'>{siteName}</div>
            <div className='text-[12px] text-[#999999]'>专业英语学习平台</div>
          </div>
        </div>
      )}
      <div
        onClick={() => {
          window.location.href = downloadUrl;
        }}
        className='bg-[#FFAA1B] text-[#FFFFFF] px-[16px] py-[6px] rounded-full text-[14px]'
      >
        立即下载
      </div>
    </div>
  );
};

export default DowloadAppBanner;
